import picksApi from "./picks";

export const { usePartiallyCompleteMutation } = picksApi;
